import Game from "Game";
import { IGameState } from "State/Game/IGameState";
import { PopupID } from "State/UI/PopupID";
import { PlayerStateHelper } from "../PlayerStateHelper";
import { PlayerTask } from "../PlayerTasks";
import { IRewardData } from "Utility/RewardHelper";
import DateHelper from "Utility/DateHelper";
import { hasFlag } from "../PlayerFlagHelper";
import { getHighestLevelCompleted } from "../PlayerLevelHelper";
import { LevelType } from "../Progress/PlayerLevels";
import { isPayer } from "../IAP/IsPayer";

export interface IPlayerCompensation {
    startDate: string;
    endDate: string;
    unlockLevel: number;
    title: string;
    description1: string;
    description2: string;
    rewards: IRewardData[];
}

export function checkPlayerCompensationEvent(state: IGameState): IGameState {
    if (isPayer(state) && !hasFlag(state.playerState, 'playerCompensation')) {
        if (Game.resource.existsAndLoaded('playerCompensation')) {
            const compensationData = Game.resource.get<IPlayerCompensation>('playerCompensation');
            const highestLevelCompleted = getHighestLevelCompleted(state.playerState, LevelType.Core);
            if (compensationData && highestLevelCompleted >= compensationData.unlockLevel && DateHelper.isBetween(compensationData.startDate, compensationData.endDate)) {
                state = {
                    ...state,
                    playerState: PlayerStateHelper.addStateTaskDatas(
                        state.playerState,
                        [
                            {
                                task: PlayerTask.SHOW_POPUP,
                                popup: PopupID.PLAYER_COMPENSATION_POPUP,
                                meta: compensationData,
                            },
                        ],
                        true
                    ),
                };
            }
        }
    }
    return state;
}